import { TicketingProvider } from '../graphql';
import { FeatureFlags } from '../third-parties';

export const TICKETING_PROVIDER_NAMES: Record<TicketingProvider, string> = {
  [TicketingProvider.Asana]: 'Asana',
  [TicketingProvider.AzureDevops]: 'Azure DevOps',
  [TicketingProvider.GithubIssues]: 'GitHub',
  [TicketingProvider.JiraCloud]: 'Jira Cloud',
  [TicketingProvider.JiraDataCenter]: 'Jira Data Center',
  [TicketingProvider.Linear]: 'Linear',
  [TicketingProvider.Trello]: 'Trello',
  [TicketingProvider.Shortcut]: 'Shortcut',
};

export const TICKETING_PROVIDER_FLAGS: Record<TicketingProvider, keyof FeatureFlags> = {
  [TicketingProvider.Asana]: 'enableAsana',
  [TicketingProvider.GithubIssues]: 'enableGithub',
  [TicketingProvider.AzureDevops]: 'enableAzureDevops',
  [TicketingProvider.JiraCloud]: 'enableJira',
  [TicketingProvider.JiraDataCenter]: 'enableJiraDataCenter',
  [TicketingProvider.Linear]: 'enableLinear',
  [TicketingProvider.Trello]: 'enableTrello',
  [TicketingProvider.Shortcut]: 'enableShortcut',
};
